const convertStringToNumber = (value) => {
  const removePlusSign = value.replace("+", "");
  return Number(removePlusSign);
};
const convertMaybeStringToNumber = (value) => {
  if (!value) {
    return;
  }
  return convertStringToNumber(value);
};
const mapClientToServerPrescription = (eyeSideConfiguration) => {
  const {
    addition: _addition,
    axis: _axis,
    baseCurve: _baseCurve,
    cylinder: _cylinder,
    diameter: _diameter,
    power: _power
  } = eyeSideConfiguration;
  if (!_power) {
    return;
  }
  return {
    addition: _addition,
    // The BE expects a string for addition
    axis: convertMaybeStringToNumber(_axis),
    cylinder: convertMaybeStringToNumber(_cylinder),
    baseCurve: convertMaybeStringToNumber(_baseCurve),
    diameter: convertMaybeStringToNumber(_diameter),
    power: convertStringToNumber(_power)
  };
};
export {
  mapClientToServerPrescription
};
//# sourceMappingURL=map-client-to-server-prescription.js.map
